var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "onboarding-connect-natives" },
    [
      _c("OnboardingSteps", {
        attrs: {
          "current-step": "natives",
          "current-network": _vm.currentNetwork,
        },
        on: { "network-selected": _vm.handleNetworkSelected },
      }),
      _c(
        "div",
        { staticClass: "onboarding-content" },
        [
          _c("div", { staticClass: "onboarding-header" }, [
            _c("div", { staticClass: "onboarding-network-icon-wrapper" }, [
              _c("img", {
                staticClass: "onboarding-network-icon",
                attrs: {
                  src: _vm.currentNetworkIcon,
                  alt: _vm.currentNetworkName,
                },
              }),
              _vm.currentPage &&
              _vm.currentPage.avatar &&
              !_vm.imageLoadErrors[_vm.currentPage.id]
                ? _c("img", {
                    staticClass: "onboarding-current-page-avatar",
                    attrs: {
                      src: _vm.currentPage.avatar,
                      alt: _vm.currentPageName,
                    },
                    on: {
                      error: function ($event) {
                        return _vm.handleImageError(_vm.currentPage.id)
                      },
                    },
                  })
                : _vm.currentPage
                ? _c(
                    "div",
                    {
                      staticClass:
                        "onboarding-current-page-avatar avatar-placeholder",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.currentPageName.charAt(0).toUpperCase()) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "onboarding-header-content" }, [
              _c("h1", { staticClass: "onboarding-header-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t("onboarding.connect_natives.connection_title", {
                        networkName: _vm.currentNetworkName,
                      })
                    ) +
                    "\n          "
                ),
                _c(
                  "svg",
                  {
                    staticClass: "native-icon",
                    attrs: {
                      width: "26",
                      height: "26",
                      viewBox: "0 0 64 64",
                      xmlns: "http://www.w3.org/2000/svg",
                      "stroke-width": "3",
                      stroke: "none",
                      fill: "#111827",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M37.34,7.36a.12.12,0,0,1,.18.13c-.47,1.86-2.78,12.63,5.57,19.62,8.16,6.84,8.41,17.13,2.33,24-7.27,8.23-19.84,6.78-25.25,1.37C16.36,48.69,9.44,36.33,21.29,26a.1.1,0,0,1,.16,0c.29,1.23,2.3,9,7.66,10,.25,0,.37-.11.25-.34C27.78,32.6,20.66,17,37.34,7.36Z",
                        "stroke-linecap": "round",
                      },
                    }),
                  ]
                ),
              ]),
              _c("p", {
                staticClass: "onboarding-header-subtitle",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("onboarding.connect_natives.connection_subtitle", {
                      pageName: _vm.currentPageName,
                    })
                  ),
                },
              }),
            ]),
          ]),
          _vm.networkFeatures.length > 0
            ? _c(
                "div",
                { staticClass: "onboarding-features-badges" },
                _vm._l(_vm.networkFeatures, function (feature) {
                  return _c(
                    "span",
                    {
                      key: feature,
                      staticClass: "onboarding-feature-badge",
                      attrs: {
                        "data-tooltip": _vm.$t(
                          `onboarding.features.${feature}.description`
                        ),
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(`onboarding.features.${feature}.title`)
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          !_vm.connectionSuccess
            ? _c("div", { staticClass: "onboarding-native-form" }, [
                _vm.connectionError
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "onboarding-message onboarding-message-error",
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "20",
                              height: "20",
                              viewBox: "0 0 20 20",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M10 6V10M10 14H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _c("span", [_vm._v(_vm._s(_vm.connectionError))]),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "onboarding-form-group" }, [
                  _c("label", { staticClass: "onboarding-form-label" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "onboarding.connect_natives.form_label_username"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.nativeCredentials.username,
                        expression: "nativeCredentials.username",
                      },
                    ],
                    staticClass: "onboarding-form-input",
                    attrs: {
                      type: "text",
                      name: "username",
                      autocomplete: "username",
                      placeholder: _vm.currentPageName,
                    },
                    domProps: { value: _vm.nativeCredentials.username },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.nativeCredentials,
                          "username",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c("div", { staticClass: "onboarding-form-group" }, [
                  _c("label", { staticClass: "onboarding-form-label" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "onboarding.connect_natives.form_label_password"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.nativeCredentials.password,
                        expression: "nativeCredentials.password",
                      },
                    ],
                    staticClass: "onboarding-form-input",
                    attrs: {
                      type: "password",
                      name: "password",
                      autocomplete: "current-password",
                      placeholder: "",
                    },
                    domProps: { value: _vm.nativeCredentials.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.nativeCredentials,
                          "password",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "onboarding-btn-connect",
                    attrs: { disabled: !_vm.canConnect || _vm.isConnecting },
                    on: { click: _vm.handleNativeConnection },
                  },
                  [
                    _vm.isConnecting
                      ? _c("span", { staticClass: "onboarding-btn-loading" }, [
                          _c(
                            "svg",
                            {
                              staticClass: "onboarding-spinner",
                              attrs: {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  opacity: "0.2",
                                  d: "M10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1Z",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M10 1C14.9706 1 19 5.02944 19 10",
                                  stroke: "currentColor",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                },
                              }),
                            ]
                          ),
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "onboarding.connect_natives.button_connecting"
                                )
                              ) +
                              "\n        "
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$t(
                                  "onboarding.connect_natives.button_connect"
                                )
                              ) +
                              "\n        "
                          ),
                        ]),
                  ]
                ),
              ])
            : _c("div", { staticClass: "onboarding-native-success" }, [
                _c("div", { staticClass: "onboarding-native-success-icon" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "64",
                        height: "64",
                        viewBox: "0 0 64 64",
                        fill: "none",
                      },
                    },
                    [
                      _c("circle", {
                        attrs: {
                          cx: "32",
                          cy: "32",
                          r: "32",
                          fill: "#10B981",
                          "fill-opacity": "0.1",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M20 32L28 40L44 24",
                          stroke: "#10B981",
                          "stroke-width": "4",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]),
                _c("h3", { staticClass: "onboarding-native-success-title" }, [
                  _vm._v(
                    _vm._s(_vm.$t("onboarding.connect_natives.success_title"))
                  ),
                ]),
                _c("p", { staticClass: "onboarding-native-success-message" }, [
                  _vm._v(
                    _vm._s(_vm.$t("onboarding.connect_natives.success_message"))
                  ),
                ]),
              ]),
          _vm.showSkipModal
            ? _c(
                "div",
                {
                  staticClass: "onboarding-skip-modal-overlay",
                  on: {
                    click: function ($event) {
                      if ($event.target !== $event.currentTarget) return null
                      return _vm.closeSkipModal.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "onboarding-skip-modal" }, [
                    _c("h4", [
                      _vm._v(
                        _vm._s(_vm.$t("onboarding.modale.native.exit.title"))
                      ),
                    ]),
                    _c("div", {
                      staticClass: "onboarding-skip-modal-body",
                      domProps: { innerHTML: _vm._s(_vm.skipModalContent) },
                    }),
                    _c(
                      "div",
                      { staticClass: "onboarding-skip-modal-buttons" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "button btn-outline-primary",
                            on: { click: _vm.closeSkipModal },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("onboarding.modale.exit.cancel")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm.nextPage
                          ? _c(
                              "div",
                              {
                                staticClass: "button btn-outline-primary",
                                on: { click: _vm.confirmSkipCurrentPage },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "onboarding.connect_natives.skip_page"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "button btn-primary",
                            on: { click: _vm.confirmSkip },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("onboarding.modale.exit.confirm")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
          _c("TwoFactorModal", {
            attrs: {
              active: _vm.twoFactorActive,
              page: _vm.refreshedCurrentPage,
            },
            on: {
              "update:active": function ($event) {
                _vm.twoFactorActive = $event
              },
              connected: _vm.handleTwoFactorSuccess,
              cancel: function ($event) {
                _vm.twoFactorActive = false
              },
            },
          }),
          _c("p", { staticClass: "onboarding-privacy-mention" }, [
            _c(
              "svg",
              {
                staticStyle: { "flex-shrink": "0" },
                attrs: {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M10 2L3 5V10C3 14.418 6.03 18.528 10 19.5C13.97 18.528 17 14.418 17 10V5L10 2Z",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("onboarding.connect_natives.privacy_mention")) +
                "\n    "
            ),
          ]),
          _c("div", { staticClass: "onboarding-footer-container" }, [
            _c("div", { staticClass: "onboarding-footer" }, [
              !_vm.connectionSuccess
                ? _c(
                    "button",
                    {
                      staticClass: "onboarding-btn-secondary",
                      attrs: { disabled: _vm.isConnecting },
                      on: { click: _vm.showSkipWarning },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("onboarding.connect_natives.skip_step")
                          ) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.connectionSuccess
                ? _c(
                    "button",
                    {
                      staticClass: "onboarding-btn-primary",
                      on: { click: _vm.continueAfterSuccess },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.continueButtonLabel) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }